module.exports = __webpack_public_path__ + "img/status-report-badge-4.3fd1d65a.svg";